/**
 * Custom Product Slider Component
 */
import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

(() => {
  if (!customElements.get("custom-product-slider")) {
    class CustomProductSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.enableLoop = this.dataset.enable_slider_loop === "true";
        this.sliderCentered = this.dataset.sliderCentered === "true";
        this.sliderFullWidth = this.dataset.sliderFullWidth === "true";
        this.slidesCount = this.querySelectorAll(".swiper-slide").length;

      }

      connectedCallback() {
        this.init();
      }

      init() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }

        const initialSliderForLargeScreens = this.slidesCount > 4 ? 4 : 0;

        const swiperConfig = {
          slidesPerView: "auto",
          spaceBetween: 20,
          loop: this.enableLoop,
          slidesOffsetAfter: this.enableLoop ? 0 : 20,
          loopedSlides: this.slidesCount,
          mousewheel: {
            forceToAxis: true,
          },
          breakpoints: {
            768: {
              spaceBetween: 30,
              initialSlide: this.sliderCentered && this.slidesCount > 9 ? 2 : 0,
              slidesOffsetAfter: this.enableLoop ? 0 : 30,
              slidesOffsetBefore: this.sliderFullWidth || !this.sliderCentered || !this.enableLoop ? 30 : 0,
              centeredSlides: this.sliderCentered && this.slidesCount > 9,
              loopAdditionalSlides: this.enableLoop ? 0 : 3,
            },
            1900: {
              slidesOffsetBefore: this.sliderFullWidth || !this.sliderCentered || !this.enableLoop ? 30 : 0,
              initialSlide: this.sliderCentered && this.slidesCount > 9 ? initialSliderForLargeScreens : 0,
              centeredSlides: this.sliderCentered && this.slidesCount > 9,
              loopAdditionalSlides: this.enableLoop ? 0 : 5,
            }
          },
        };
        

        try {
          this.swiper = new Swiper(this, swiperConfig);
        } catch (error) {
          console.error("Error initializing Swiper:", error);
        }
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }

    customElements.define("custom-product-slider", CustomProductSlider);
  }
})();
